// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-0b1e3c28] {\n  color: #3C4B64;\n}\n.usersHeader[data-v-0b1e3c28], .usersBody[data-v-0b1e3c28] {\n  padding: 3px 0px;\n}\n\n", ""]);
// Exports
module.exports = exports;
